import moment from "moment"

const ExpandedRowContent = ({ data }) => {
  // Sample milestone data - you can modify this based on your actual data structure
  const milestones = [
    {
      label: "Executed LOI",
      labelCheck: "Executed LOI",
      date: data?.executed_loi_date,
      completed: !!data?.executed_loi_completed_date,
      key: "executed_loi_date",
    },
    {
      label: "Purchase Agreement Draft Distributed",
      labelCheck: "PSA Distributed",
      date: data?.purchase_agreement_draft_distributed,
      completed: !!data?.purchase_agreement_draft_distributed_completed_date,
      key: "purchase_agreement_draft_distributed",
    },
    {
      label: "Executed Purchase Agreeement",
      labelCheck: "PSA Executed",
      date: data?.executed_purchase_agreeement,
      completed: !!data?.executed_purchase_agreeement_completed_date,
      key: "executed_purchase_agreeement",
    },
    {
      label: "Due Diligence Delivery Date",
      labelCheck: "DD Delivery Date",
      date: data?.due_diligence_delivery_receipt_confirmed,
      completed: !!data?.due_diligence_delivery_receipt_confirmed_completed_date,
      key: "due_diligence_delivery_receipt_confirmed",
    },
    {
      label: "Title",
      labelCheck: "Title",
      date: data?.title,
      completed: !!data?.title_completed_date,
      key: "title",
    },
    {
      label: "Cordinate Inspection",
      labelCheck: "Cordinate Inspection",
      date: data?.cordinate_inspection,
      completed: !!data?.cordinate_inspection_completed_date,
      key: "cordinate_inspection",
    },
    {
      label: "Due Diligence Expiration",
      labelCheck: "Due Diligence Expiration",
      date: data?.due_diligence_expiration_date,
      completed: !!data?.due_diligence_expiration_date_completed_date,
      key: "due_diligence_expiration_date",
    },
    {
      label: "Estoppel & SNDA Ordered",
      labelCheck: "Estoppel & SNDA Ordered",
      date: data?.estoppel_snda_ordered,
      completed: !!data?.estoppel_snda_ordered_completed_date,
      key: "estoppel_snda_ordered",
    },
    {
      label: "Financing Approval",
      labelCheck: "Financing Approval",
      date: data?.financing_approval,
      completed: !!data?.financing_approval_completed_date,
      key: "financing_approval",
    },
    {
      label: "Estoppel & SNDA Received",
      labelCheck: "Estoppel & SNDA Received",
      date: data?.estoppel_snda_received,
      completed: !!data?.estoppel_snda_received_completed_date,
      key: "estoppel_snda_received",
    },
    {
      label: "Commission Invoice & Wiring Instructions Sent",
      labelCheck: "Commission Invoice & <br>Wiring Instructions Sent",
      date: data?.comission_invoice_wiring_instruction,
      completed: !!data?.comission_invoice_wiring_instruction_completed_date,
      key: "comission_invoice_wiring_instruction",
    },
    {
      label: "Closing Scheduled",
      labelCheck: "Closing Scheduled",
      date: data?.scheduled_closing,
      completed: !!data?.scheduled_closing_completed_date,
      key: "closed_date",
    },
  ]

  // ❗ FIX: Use the SAME sliced array everywhere in the top timeline
  const visibleMilestones = milestones.slice(0, 12)

  const formatDate = (dateString) => {
    if (!dateString) return ""
    return moment.tz(dateString, "America/New_York").format("MM/DD/YYYY")
  }

  const completedCount = milestones.filter((m) => m.completed).length

  return (
    <div className="expanded-row-content p-6 bg-[rgb(244,244,244)] rounded-md">
      <div className="mb-4 overflow-x-auto">

        {/* PERFECT 2-ROW TIMELINE (NO MISALIGNMENT EVER) */}
        <div className="flex pb-4">
          {visibleMilestones.map((milestone, index) => (
            <div key={milestone.key} className="flex items-start">

              {/* EACH STEP */}
              <div className="flex flex-col items-center w-24">

                {/* FIXED BUBBLE ROW */}
                <div className="h-10 flex items-center justify-center">
                  <div
                    className={`w-8 h-8 rounded-full border-2 flex items-center justify-center ${milestone.completed
                      ? "bg-green-600 border-green-600 text-white"
                      : "bg-white border-gray-300 text-gray-400"
                      }`}
                  >
                    {milestone.completed ? (
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    ) : (
                      <span></span>
                    )}
                  </div>
                </div>

                {/* LABEL (CAN WRAP WITHOUT AFFECTING BUBBLE ALIGNMENT) */}
                <div className="mt-2 text-center px-1">
                  <span className="body-XS break-words">
                    {/* {milestone.labelCheck} */}
                    <label dangerouslySetInnerHTML={{ __html: milestone.labelCheck }} />
                  </span>
                </div>
              </div>

              {/* CONNECTOR LINE */}
              {index < visibleMilestones.length - 1 && (
                <div className="flex items-center mt-5 mx-2">
                  <div
                    className={`w-12 h-0.5 ${milestone.completed && visibleMilestones[index + 1]?.completed
                      ? "bg-green-600"
                      : milestone.completed
                        ? "bg-gradient-to-r from-green-600 to-gray-300"
                        : "bg-gray-300"
                      }`}
                  ></div>
                </div>
              )}
            </div>
          ))}
        </div>


      </div>

      {/* LOWER SECTION – unchanged */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="lg:col-span-1">
          <div className="space-y-3">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className="grid grid-cols-12 items-center pb-2 border-b border-gray-200 last:border-b-0"
              >
                <span className="col-span-6 body-S font-medium">{milestone.label}</span>

                <span className="col-span-4 body-S text-center">
                  {milestone.date ? milestone.date : ""}
                </span>

                <span className="col-span-2 text-right">
                  {milestone.completed && <span className="text-green-600 body-XS">✓</span>}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExpandedRowContent
